import axios from 'axios'
import env from '@env'

export default class DeskAPI {
  static getTableStatusList () {
    return Promise.resolve({})
  }

  static postCleanUpTable (params: { tableCode: string }) {
    return Promise.resolve({})
  }

  static getTableByTableCode (params: any) {
    const url = `${env.ORDERJMOBILE}/getTableByTableCode`
    return axios.post(url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
}
